module.exports = __webpack_public_path__ + "img/IMG_1322.8344cc20.jpg";